import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import server from '../../apis/server';
import { ERROR_MESSAGES } from '../common/ErrorMessage';

const TenantTokenRedirect = ({ match }) => {
  const { token } = match.params;
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    if (!token) {
      setError({
        code: 'REDIRECT_INVALID_TOKEN',
        message: ERROR_MESSAGES.REDIRECT_INVALID_TOKEN?.message || 'Länken är tyvärr inte giltig.',
      });
      return () => { isMounted = false; };
    }

    const resolveRedirect = async () => {
      try {
        const apiUrl = `/redirect/${encodeURIComponent(token)}`;

        const { data } = await server.get(apiUrl, { params: { format: 'json' } });
        if (!isMounted) return;

        if (data?.targetUrl) {
          window.location.replace(data.targetUrl);
        } else {
          setError({
            code: 'REDIRECT_INVALID_TOKEN',
            message: ERROR_MESSAGES.REDIRECT_INVALID_TOKEN?.message || 'Länken är tyvärr inte giltig.',
          });
        }
      } catch (err) {
        if (!isMounted) return;

        const errorCode = err?.response?.data?.code || 'REDIRECT_INVALID_TOKEN';
        const errorMessage = ERROR_MESSAGES[errorCode] || ERROR_MESSAGES.REDIRECT_INVALID_TOKEN;

        setError({
          code: errorCode,
          message: errorMessage?.message || 'Länken är tyvärr inte giltig.',
        });
      }
    };

    resolveRedirect();

    return () => {
      isMounted = false;
    };
  }, [token]);

  if (error) {
    return (
      <div className="ui container" style={{ maxWidth: 420, marginTop: 80, textAlign: 'center' }}>
        <div className="ui negative message" style={{ textAlign: 'left' }}>
          <p>{error.message}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="redirect-loader-overlay">
      <div className="ui active inline loader" />
    </div>
  );
};

TenantTokenRedirect.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token: PropTypes.string,
    }),
  }).isRequired,
};

export default TenantTokenRedirect;
